import React from "react";
import { Index } from "../components/Home/Index";

export const Home = () => {
  return <Index />;
};
